import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {defaultGuards} from '../app-routing.module';
import {BusinessServicesComponent} from './business-services.component';
import {BusinessCreditReportComponent} from './business-credit-report/business-credit-report.component';
import {BusinessUserGuard} from '../_guards/business-user.guard';

const businessUserGuards = [...defaultGuards, BusinessUserGuard];

const routes: Routes = [

  //Don't use "children" routes without a nested <router-outlet></router-outlet>
  //This module is lazy-loaded.  So every route in this routing module is a child route of business-services
  {path: '', pathMatch: 'full', component: BusinessServicesComponent, canActivate: businessUserGuards},
  {path: 'credit-report', pathMatch: 'full', component: BusinessCreditReportComponent, canActivate: businessUserGuards}

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BusinessServicesRoutingModule {}
